import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../ab_testing/ongoing_ab_tests";

export const multiLeadSummaryAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.MULTI_LEAD_SUMMARY);
import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../ab_testing/ongoing_ab_tests";

export const multiLeadSummaryAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.MULTI_LEAD_SUMMARY);
